import React from "react";

import bgHeader from "./../graphics/elements/leagueBgHeader.svg";
import styles from "./HeaderTopic.module.css";
import { isDevToolsEnvironment } from './DevToolsFloatingButton';

function HeaderTopic(props) {
  let { topic } = props;


  return (
    <div>
      <div className={styles.header}>
        <img src={bgHeader} alt="כותרת" />
        <h1 style={{fontSize: '1.5em'  , display: 'flex', justifyContent: 'center'}}>
         <span style={{display: 'flex',maxWidth: '70vw', overflow: 'ellipsis'}}>{topic}


          </span>
          </h1>

      </div>
    </div>
  );
}

export default HeaderTopic;
